import React, { useEffect, useState } from 'react'
import { DataItem, BBDTag } from '@gravitate-js/excalibrr'
import { Col, Form, Row, Select, Switch } from 'antd'
import { FormInput } from '../../../../../_SiteWide/Form/FormInput'
import { CustomSelect } from '../../../../../_SiteWide/Form/DropdownSelect'
import { useRef } from 'react'
const { Option } = Select
export const StoreInfoRows = ({ tank, metadata, editing, form }) => {
  const [disableIsland, setDisableIsland] = useState(!!tank.carrier)
  const wrapperRef = useRef(null)
  const carrierOnChange = (value) => {
    if (value) {
      form.setFieldsValue({ island: 'carrier' })
    } else {
      form.setFieldsValue({ island: 'auto' })
    }
    setDisableIsland(!!value)
  }

  useEffect(() => {
    form.setFieldsValue({ island: tank.island, carrier_id: tank.carrier_id })
  }, [tank])
  return (
    <Row className='mt-3'>
      <Col span={12}>
        <DataItem label='Island'>
          <FormInput
            name='island'
            disabled={disableIsland}
            placeholder='Island'
            width='90%'
            editable={editing}
            initialValue={tank.island}
          />
        </DataItem>
      </Col>

      <Col span={12}>
        <DataItem label='Tank Carrier'>
          <div ref={wrapperRef}>
            <Form.Item name='carrier_id'>
              {editing ? (
                <Select
                  getPopupContainer={(_) => wrapperRef?.current}
                  onChange={carrierOnChange}
                  filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  placeholder='Search for a Tank Carrier'
                  allowClear
                  showSearch
                  style={{ width: '100%' }}
                >
                  {metadata?.carriers.map((carrier, i) => (
                    <Option key={i} value={carrier.id}>
                      {carrier.name}
                    </Option>
                  ))}
                </Select>
              ) : (
                tank.carrier || 'N/A'
              )}
            </Form.Item>
          </div>
        </DataItem>
      </Col>

      <Col span={12}>
        <DataItem label='Tank Tags'>
          {editing ? (
            <CustomSelect
              name='filter_tags'
              placeholder='Tank Tags'
              width='90%'
              options={metadata?.filter_tags || []}
              editable={editing}
              initialValue={tank?.filter_tags?.length > 0 ? tank.filter_tags : 'No Tags'}
            />
          ) : (
            <Col align='left' span={24}>
              {tank.filter_tags.map((tag) => (
                <BBDTag key={tag.index}>{tag}</BBDTag>
              ))}
            </Col>
          )}
        </DataItem>
      </Col>

      <Col span={6}>
        <DataItem label='Requires Pump'>
          {editing ? (
            <Form.Item name='requires_pump' valuePropName='checked'>
              <Switch checkedChildren='Yes' unCheckedChildren='No' />
            </Form.Item>
          ) : tank.requires_pump === true ? (
            <BBDTag theme2>Yes</BBDTag>
          ) : (
            'No'
          )}
        </DataItem>
      </Col>

      <Col span={6}>
        <DataItem label='Hide Tank Alerts'>
          {editing ? (
            <Form.Item name='hide_tank_alerts' valuePropName='checked'>
              <Switch checkedChildren='Yes' unCheckedChildren='No' />
            </Form.Item>
          ) : tank.hide_tank_alerts ? (
            <BBDTag warning>Yes</BBDTag>
          ) : (
            'No'
          )}
        </DataItem>
      </Col>
    </Row>
  )
}
